var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bi:person"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 13.5C14.2929 13.5 15.5329 12.9864 16.4471 12.0721C17.3614 11.1579 17.875 9.91793 17.875 8.625C17.875 7.33207 17.3614 6.09209 16.4471 5.17785C15.5329 4.26361 14.2929 3.75 13 3.75C11.7071 3.75 10.4671 4.26361 9.55285 5.17785C8.63861 6.09209 8.125 7.33207 8.125 8.625C8.125 9.91793 8.63861 11.1579 9.55285 12.0721C10.4671 12.9864 11.7071 13.5 13 13.5ZM16.25 8.625C16.25 9.48695 15.9076 10.3136 15.2981 10.9231C14.6886 11.5326 13.862 11.875 13 11.875C12.138 11.875 11.3114 11.5326 10.7019 10.9231C10.0924 10.3136 9.75 9.48695 9.75 8.625C9.75 7.76305 10.0924 6.9364 10.7019 6.3269C11.3114 5.71741 12.138 5.375 13 5.375C13.862 5.375 14.6886 5.71741 15.2981 6.3269C15.9076 6.9364 16.25 7.76305 16.25 8.625ZM22.75 21.625C22.75 23.25 21.125 23.25 21.125 23.25H4.875C4.875 23.25 3.25 23.25 3.25 21.625C3.25 20 4.875 15.125 13 15.125C21.125 15.125 22.75 20 22.75 21.625ZM21.125 21.6185C21.1234 21.2188 20.8748 20.0162 19.773 18.9145C18.7135 17.855 16.7196 16.75 13 16.75C9.27875 16.75 7.2865 17.855 6.227 18.9145C5.12525 20.0162 4.87825 21.2188 4.875 21.6185H21.125Z",
    fill: "#202020"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiPerson);
export default __webpack_public_path__ + "static/media/bi_person.c9b324535ea3eee6b38e62e99b14c19b.svg";
export { ForwardRef as ReactComponent };